import React, { useEffect, useState } from "react";
import { getDomain } from "../../constants";
import EnvironmentSelector from "../options/environment_selector";
import InvisibleRequest from "../options/invisible_request";
import EmbedContainer from "../embed/container";

const buildUrl = (baseUrl, params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, String(value));
  });

  const query = searchParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
};

const paramsByEnv = {
  development: {
    token: "VumTXJXX3czkDbk69fxUTtEd9xM9iZ3n",
    locale: "fr",
    invisible: true,
    autoCreate: false,
  },
  staging: {
    token: "VumTXJXX3czkDbk69fxUTtEd9xM9iZ3n",
    locale: "fr",
    invisible: false,
    autoCreate: false,
  },
  validation: {
    token: "jqtwXKFcGMJG7cd1ekkmWP76JM8Mz4ZH",
    locale: "fr",
    invisible: false,
    autoCreate: false,
  },
  production: {
    token: "p3A6BshBJ9QXJMsG8Wa3UGhgzRsKgpWD",
    locale: "fr",
    invisible: false,
    autoCreate: false,
  },
};

const AprilDemo = () => {
  const [token, setToken] = useState("");
  const [locale, setLocale] = useState("fr");
  const [environment, setEnvironment] = useState("staging");
  const [invisible, setInvisible] = useState(false);
  const [autoCreate, setAutoCreate] = useState(false);
  const domain = getDomain(environment);

  const changeEnvironment = (env) => {
    setEnvironment(env);
    setToken(paramsByEnv[env].token);
    setLocale(paramsByEnv[env].locale);
    setInvisible(paramsByEnv[env].invisible);
    setAutoCreate(paramsByEnv[env].autoCreate);
  };

  useEffect(() => {
    changeEnvironment("validation");
  }, []);

  return (
    <div>
      <h1>April Demo</h1>
      <EnvironmentSelector
        value={environment}
        onChange={(env) => changeEnvironment(env)}
      />
      <InvisibleRequest onChange={(invisible) => setInvisible(invisible)} />
      <div>
        <label style={{ marginRight: "10px" }}>Locale:</label>
        <select value={locale} onChange={(e) => setLocale(e.target.value)}>
          <option value="fr">FR</option>
          <option value="nl">NL</option>
        </select>
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Auto Create:</label>
        <input
          type="checkbox"
          checked={autoCreate}
          onChange={(e) => setAutoCreate(e.target.checked)}
        />
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Embed Token:</label>
        <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
      </div>
      {token && (
        <div key={`${token}-${locale}-${autoCreate}`}>
          <EmbedContainer
            embedUrl={buildUrl(domain, {
              aet: token,
              brand: "april",
              theme: "april",
              locale,
              invisible,
              autoCreate,
            })}
            showCode={true}
            urlToShow={buildUrl(domain, {
              aet: token,
              brand: "april",
              theme: "april",
              locale,
              autoCreate,
            })}
          />
        </div>
      )}
    </div>
  );
};

export default AprilDemo;
